import React, { useEffect, useState } from 'react';
import GlobalStyles from '@mui/joy/GlobalStyles';
import Avatar from '@mui/joy/Avatar';
import Box from '@mui/joy/Box';
import Divider from '@mui/joy/Divider';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemButton, { listItemButtonClasses } from '@mui/joy/ListItemButton';
import ListItemContent from '@mui/joy/ListItemContent';
import Typography from '@mui/material/Typography';
import Sheet from '@mui/joy/Sheet';
import { closeSidebar } from '../common/utils';
import {  FaEdit } from 'react-icons/fa';
import {  FaRepeat } from "react-icons/fa6";
import { getResponseType, saveResponseType } from '../../libs/common/storage';
export default function Sidebar({ clearMessages, themeMode,setSidebarOpen }: any) {
  const [responseType, setResponseType] = useState(1); // Default to "concise"

  useEffect(() => {
    setResponseType(getResponseType())
  },)

  const updateResponseType = (int: number) => {
    setResponseType(int);
    saveResponseType(int);
  }


  return (
    <Sheet
      className={themeMode ? 'Sidebar' : 'LightSidebar'}      
      sx={{
        position: { xs: 'fixed', md: 'sticky' },
        transform: {
          xs: 'translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1)))',
          md: 'none',
        },
        transition: 'transform 0.4s, width 0.4s',
        zIndex: 10000,
        backgroundColor: "white",
        width: 'var(--Sidebar-width)',
        top: 0,
        p: 2,
        flexShrink: 0,
        boxShadow: themeMode ? "2px 0px 10px black;" : "none",
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        borderRight: '0px solid',
        borderColor: '1px solid #000',
      }}
    >
      <GlobalStyles
        styles={(theme) => ({
          ':root': {
            '--Sidebar-width': '220px',
            [theme.breakpoints.up('lg')]: {
              '--Sidebar-width': '240px',
            },
          },
        })}
      />
      <Box
        className="Sidebar-overlay"
        sx={{
          position: 'fixed',
          zIndex: 9998,
          top: 0,
          left: 0,
          width: '100vw',
          boxShadow: "2px 0px 10px black;",
          height: '100vh',
          transition: 'opacity 0.4s',
          transform: {
            xs: 'translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1) + var(--SideNavigation-slideIn, 0) * var(--Sidebar-width, 0px)))',
            lg: 'translateX(-100%)',
          },
        }}
        onClick={() => closeSidebar()}
      />
      <Box sx={{ display: "flex" }}>
        <img
          src={
            !themeMode?
            require("../../assets/imgs/png/full-logo.png"):
            require("../../assets/imgs/png/soe-logo-topbar.png")
          }
          alt="Logo"
          style={{ width: "200px", height: "auto" }} 
        />
      </Box>

      <Divider />
      <Box
        sx={{
          minHeight: 0,
          overflow: 'hidden auto',
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          [`& .${listItemButtonClasses.root}`]: {
            gap: 1.5,
          },
        }}
      >
        <List
          size="sm"
          sx={{
            gap: 1,
            '--List-nestedInsetStart': '30px',
            '--ListItem-radius': (theme) => theme.vars.radius.sm,
          }}
        >
          <ListItem>
            <ListItemButton component="a" onClick={() => {clearMessages();setSidebarOpen(false)}}>
              <FaEdit />
              <ListItemContent>
                <Typography className="side-link">New Chat</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>

          <ListItem>
            <ListItemButton component="a" onClick={() => {clearMessages();setSidebarOpen(false)}}>
              <FaRepeat className="indigo-clr" />
              <ListItemContent>
                <Typography className="side-link">Reset Chat</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>

          {/* <ListItem className="test" style={{ backgroundColor: "transparent" }}>
            <Accordion expanded disabled sx={{ boxShadow: "none", width: "100%", background: "transparent !important", backgroundColor: "transparent !important", border: 0 }}>
              <AccordionSummary
                expandIcon={<FaChevronDown style={{ color: "White" }} />}
                sx={{ paddingLeft: 0 }}>
                <FaMessage style={{ marginRight: 12, marginTop: 5, color: "white", fontSize: 15 }} />
                <Typography fontStyle={{ color: "white !important", }}>Response Type</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <RadioGroup
                  value={responseType}
                  onChange={(event) => setResponseType(Number(event.target.value))}
                  sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                >
                  <Radio value={1} color='success' onChange={() => updateResponseType(1)} style={{color: "white"}} label="Concise" />
                  <Radio value={2} color='success' onChange={() => updateResponseType(2)} style={{color: "white"}} label="Summarized" />
                  <Radio value={3} color='success' onChange={() => updateResponseType(3)} style={{color: "white"}} label="Detailed" />
                </RadioGroup>
              </AccordionDetails>
            </Accordion>
          </ListItem> */}


        {/*   <ListItem>
            <ListItemButton component="a">
              <FaGear className="indigo-clr" />
              <ListItemContent>
                <Typography className="side-link">Settings</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem> */}
        </List>

      </Box>
    </Sheet >
  );
}